import {
  Component, ViewEncapsulation, ChangeDetectionStrategy, Input
} from '@angular/core';

import { luggageTooltipParentTypes } from '@ux/entities/tooltip-types';
import { LuggageService } from '@shared/luggage/services/luggage.service';
import { TypeOfLuggage } from '@shared/luggage/constants/type-luggage';
import { Icon, IconFillColor } from '@design-system/components/atoms/icon/entities/icon.types';
import {
  TypographyColor, TypographyFontFamily, TypographyFontSize
} from '@design-system/components/atoms/typography/entities/typography.types';
import { BackgroundSurfaceType } from '@design-system/components/atoms/background-surface/entities/background-surface.types';

@Component({
  selector: 'app-luggage-tooltip',
  templateUrl: './luggage-tooltip.component.html',
  styleUrls: ['./luggage-tooltip.component.sass'],
  encapsulation: ViewEncapsulation.ShadowDom,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})

export class LuggageTooltipComponent {

  private classContainer: string = 'tooltip-container';

  @Input() handBaggage: boolean;
  @Input() baggage: number = null;
  @Input() airline: string;
  @Input() fareFamily: string;
  @Input() fareBasis: string;
  @Input() parent: luggageTooltipParentTypes = null;
  @Input() showShadow: boolean = true;
  @Input() lateralPadding: boolean = false;
  @Input() showArrow: boolean = true;
  @Input() typeOfLuggage: TypeOfLuggage = TypeOfLuggage.ByPieces;
  @Input() departureDate: string = null;
  @Input() departureAirport: string = null;
  @Input() arrivalAirport: string = null;
  @Input() isInternational: boolean;

  public readonly backpack = Icon.Backpack;
  public readonly handLuggage = Icon.HandLuggage;
  public readonly luggage = Icon.Luggage;

  public readonly subtitleColor = TypographyColor.Secondary;

  public readonly xxxsFontSize = TypographyFontSize.XXXS;
  public readonly xsFontSize = TypographyFontSize.XS;

  public readonly semiBoldFontFamily = TypographyFontFamily.SemiBold;

  public readonly backgroundSurface = BackgroundSurfaceType.Primary;

  public readonly primaryTypographyColor = TypographyColor.Primary;

  constructor(
    private luggageService: LuggageService
  ) { }

  get includesLuggageWarehouse(): boolean {
    return this.luggageService.includesLuggageWarehouse(this.baggage);
  }

  get warehouseTitle(): string {
    return this.luggageService.warehouseTitle(this.baggage);
  }

  get warehouseSubtitle(): string {
    return this.luggageService.warehouseSubtitle(this.baggage, this.typeOfLuggage);
  }

  get disableBackpackLuggage(): boolean {
    return this.luggageService.disableBackpackLuggage(this.airline);
  }

  get includesHandBaggageText(): string {
    return this.handBaggage ? 'LUGGAGE_MODULE.BAGGAGE.HAND_BAGGAGE' : 'LUGGAGE_MODULE.BAGGAGE.NO_HAND_BAGGAGE';
  }

  get backpackLuggageText(): string {
    return this.disableBackpackLuggage ? 'LUGGAGE_MODULE.BAGGAGE.NO_BACKPACK_BAGGAGE' : 'LUGGAGE_MODULE.BAGGAGE.BACKPACK_BAGGAGE';
  }

  get className(): string {
    return `${this.classContainer} ${this.parent}`;
  }

  public getIconColor(enabled: boolean): IconFillColor {
    return enabled ? IconFillColor.Highlight : IconFillColor.Secondary;
  }

  public getTypographyColor(enabled: boolean): TypographyColor {
    return enabled ? TypographyColor.Highlight : TypographyColor.Secondary;
  }
}
